module.exports = parcelRequire.resolve("7znd4");